<template>
  <div class="PayNowSuccessful">
    <confirmation-banner
      icon-name="tick-success"
      :title="$t('subscription_buynow.paymentSuccessful.info', 'The payment was succesful.')"
      :description="$t('subscription_buynow.paymentSuccessful.infoEmail', 'You will recieve a confirmation email shortly, please confirm and start shipment.Your subscription account')"
    />
    <div class="PayNowSuccessful_body">
      <div class="backpage container">
        <router-link
          :to="{ name: 'my-account' }"
          class="AppButton back"
          @click.native="trackConversion({ name: 'interaction', description: 'back_to_payment_details' })"
        >
          ‹ {{ $t('subscription_buynow.button.back', 'Back to payment details') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import ConfirmationBanner from 'components/ConfirmationBanner'

  export default {
    name: 'pay-now-successful',

    components: {
      ConfirmationBanner
    }
  }
</script>

<style lang="scss">
  .PayNowSuccessful {
    &_body {
      padding: .27rem 0 1rem;
      text-align: center;

      @include media(tablet) {
        padding: .37rem 0 1.25rem;
      }

      .backpage {
        .back {
          background: $white;
          color: $blue;
          border: .01rem solid $blue;
          padding: .07rem .15rem;
          font-weight: 400;

          @include media(tablet) {
            min-width: 3.55rem;
          }
        }
      }
    }
  }
</style>
